import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/fsd/us/en';
import { CarPageTemplate } from '@/pageTemplate/CarPageTemplate';
import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';

const FSDGlobalStyle = createGlobalStyle`
  footer {
    background-color: black !important;
    border-top: 2px solid black !important;
    z-index: 1000 !important;
  }
`;

export default function FSDPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('fsd_page.viewed', {
        variant: 'default',
        priceType: 'fixed',
      }),
    [],
  );

  return (
    <>
      <FSDGlobalStyle />
      <CarPageTemplate config={config} isNjEnabled={false} />
    </>
  );
}
